import { createI18n } from 'vue-i18n'

import en from './en.json'
import ru from './ru.json'


function customRule(choice) {
	if (choice === 0) {
		return 0;
	}
	const teen = (choice % 100) > 10 && (choice % 100) < 20;
	if (teen) {
		return 3;
	}
	const lastDigit = choice % 10;
	if (lastDigit === 1) {
		return 1;
	}
	if (lastDigit >= 2 && lastDigit <= 4) {
		return 2;
	}
	return 3;
}

const messages = {
	en: en,
	ru: ru,
}

const i18n = createI18n({
	locale: 'ru',
	fallbackLocale: 'ru',
	legacy: false,
	pluralRules: {
		ru: customRule,
	},
	messages,
})

export default i18n
